import { gql } from '@apollo/client';
import type { DateRange, UUID } from '@cobliteam/common-types';
import graphQLRequester from '../../request/GraphQLRequester';
import type { ProofOfConclusion } from './definitions';
import { proofOfConclusionAttributes } from './definitions/queriesAttributes';

export class GraphQLProofOfConclusionRequester {
  public listProofsOfConclusion = (limit: number, offset: number, period?: DateRange, activityId?: UUID, groupIds?: string[]): Promise<ProofOfConclusion[]> =>
    graphQLRequester
      .query<{ proofsOfConclusion: ProofOfConclusion[] }>({
        query: gql`
      query GetProofsOfConclusion($period: DateRange, $offset: Int, $limit: Int, $activityId: ID, $groupIds: [ID]) {
        proofsOfConclusion(period: $period, offset: $offset, limit: $limit, activityId: $activityId, groupIds: $groupIds) {
          ${proofOfConclusionAttributes}
        }
      }
    `,
        variables: { period, offset, limit, activityId, groupIds },
      })
      .then((result) => result.proofsOfConclusion);
}

export default GraphQLProofOfConclusionRequester;
